<template>
    <div class="main">
        <div class="modal fade bs-example-modal-lg" id="videoModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <video src="movie.mp4" controls="controls"></video>
                </div>
            </div>
        </div>
        <div class="p-banner" :style="'background-image: url('+banner+');'"> </div>
       <div class="container">
			<div class="box companyProfile-box">
				<div class="box-til text-center">
					<h4>感谢您对{{$website_name}}咨询的关注</h4>
					<h2>请根据具体问题，选择联系方式</h2>
					<small>PLEASE SELECT CONTACT INFORMATION ACCORDING TO SPECIFIC QUESTIONS</small>
				</div>
				<div class="row contact-box">
					<div class="col-md-4">
						<p><label>电话/微信：</label><strong>13031839005</strong></p>
						<p><label>邮箱：</label><strong>kellong@meshnb.com</strong></p>
					</div>
					<div class="col-md-4">
						<div>
							<p><img src="../assets/img/conde2.jpg" alt="" width="120"></p>
							<h4>扫码加微信</h4>
						</div>
					</div>
					<div class="col-md-4">
						<a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=95734172&site=qq&menu=yes"><img border="0" src="http://wpa.qq.com/pa?p=2:95734172:53" alt="95734172" title="95734172"/></a>
						
					</div>
				</div>
				<div class="map-box" id="allmap" style="width: 100rem;height: 50rem;">
					
				</div>
			</div>
		</div>
    </div>
</template>

<script>
    import banner from "../assets/img/banner4.jpg";
    export default {
        name: 'ContactUs',
        data :function() {
            return {
                banner: banner,
				position: {
								name: this.$website_name,
								address: '河北省衡水市安平县南方工业园12号',
								phone: '13031839005',
								lng: 115.524277,
								lat: 38.223861
							}
            }
        },
        created:function () {
			
        },
		mounted:function(){
			this.baiduMap()
		},
        methods:{
			baiduMap:function() {
				var map = new BMap.Map('allmap'); // 创建地图实例
				map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
				map.addControl(new BMap.NavigationControl());
				map.addControl(new BMap.ScaleControl());
				map.addControl(new BMap.OverviewMapControl());
				map.addControl(new BMap.MapTypeControl());
				// map.setMapStyle({ style: 'midnight' }) //地图风格
	 
				map.clearOverlays();
				//将数据遍历
				//自定义信息窗口内容
				var sContent =
					'<div style="width:500px;">'+
						'<p style="font-size:16px;font-weight:bold;margin-top: 10px;color:#1d499a">' + this.position.name + '</p>' +
						'<p style="font-size:13px;margin: 5px 0;font-weight:bold;margin-top: 10px;color:#D07852"">电话/微信：' + this.position.phone + '</p>' +
						'<p style="font-size:13px;margin: 5px 0;">工厂地址：' + this.position.address + '</p>' +
						'<p style="font-size:13px;margin: 5px 0;">主要产品：不锈钢筛网、不锈钢过滤网、轧花网、席型网、反差网，我厂还可以根据行业要求定做各种规格过滤网片、过滤网筒、塑料颗粒过滤网、橡胶过滤网等深加工产品。' +
						'<p style="font-size:13px;margin: 5px 0;">公司生产设备全部采用国际先进的数控剑杆及剑带织机，严格按照市场和消费者的要求进行高效生产，保证产品质量，满足消费者的期望，真正做到高品质，工厂价。' +
				('</div>');
				var point = new BMap.Point(this.position.lng, this.position.lat); // 创建点坐标
				var marker = new BMap.Marker(point);
				map.addOverlay(marker);
				map.centerAndZoom(point, 18); // 初始化地图，设置中心点坐标和地图级别
				// //点击图标时候调用信息窗口
				var infoWindow = new BMap.InfoWindow(sContent);
				// marker.addEventListener('click', function() {
				// 	this.openInfoWindow(infoWindow);
				// });
				marker.openInfoWindow(infoWindow);
			}
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
